import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hi from "./locales/hi.json";

// Initialize i18next
i18n
  .use(initReactI18next) // Connects i18n with React
  .init({
    resources: {
      en: {
        translation: en,
      },
      hi: {
        translation: hi,
      },
    },
    // Check the language in localStorage, fallback to 'hi' if not set
    lng: localStorage.getItem("selectedLanguage") || "hi", // Default language from localStorage or 'hi'
    fallbackLng: "en", // Fallback language if the current language doesn't have the translation
    interpolation: {
      escapeValue: false, // React already escapes variables
    },
  });

export default i18n;
